import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { TextareaAutosize } from '@material-ui/core';

const styles = theme => ({
  editor: {
    width: '100%',
  },
  label: {
    color: theme.palette.facet.primaryGray,
  },
  description: {
    marginBottom: theme.spacing(1),
  },
});

const TextAreaWithLabel = ({ classes, label, ...rest }) => {
  return (
    <div className={classes.description}>
      <Typography className={classes.label} variant="body1">{label}</Typography>
      <TextareaAutosize className={classes.editor} {...rest} />
    </div>
  );
};

export default withStyles(styles)(TextAreaWithLabel);
